import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import api from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function ProfileCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setSession(r.data.token, r.data.user);
        window.history.replaceState(null, "", "/profile");
        toast.success(`Welcome, ${r.data.user.name}`);
        const role = r.data.user.role;
        navigate(
          role === "admin" || role === "manager" ? "/admin" : role === "chef" ? "/chef" : "/",
          { replace: true }
        );
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-2 border-[#C9962F] border-t-transparent rounded-full mx-auto mb-4" />
        <p className="small-caps text-[11px] tracking-wide text-neutral-400">Signing you in…</p>
      </div>
    </div>
  );
}
